/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import ourServiceImg01 from "@/src/assets/img/ourService/ourService01.png";
import ourServiceImg02 from "@/src/assets/img/ourService/ourService02.png";
import ourServiceImg03 from "@/src/assets/img/ourService/ourService03.png";
import ourServiceImg04 from "@/src/assets/img/ourService/ourService04.png";
import ourServiceImg05 from "@/src/assets/img/ourService/ourService05.png";

export const ourServiceContent = [
  {
    id: "01",
    title: "Direkt starten: Schildern Sie uns Ihren Fall",
    description:
      "Starten Sie direkt und ohne Wartezeit. Wir führen Sie gezielt durch die wichtigsten Fragen zu Ihrem Fall. Das dauert nur wenige Minuten und stellt sicher, dass Ihre Rechtsexperten sofort alle Fakten haben, um mit der Prüfung zu beginnen und Ihnen schnellstmöglich helfen können.",
    image: {
      src: ourServiceImg01,
    },
  },
  {
    id: "02",
    title: "Dokumente und Details",
    description:
      "Alles Wichtige an einem Ort. Bilder, Schriftwechsel, Videos - alles zu Ihrem Fall können Sie uns ganz einfach und jederzeit in der Servicewelt zur Verfügung stellen.",
    image: {
      src: ourServiceImg02,
    },
  },
  {
    id: "03",
    title: "Schnelle, professionelle Prüfung",
    description:
      "Gebündelte Expertise für das beste Vorgehen. Ihr Anliegen wird detailliert geprüft, um Ihnen das beste Vorgehen zu ermöglichen und Ihnen eine realistische und ehrliche Einschätzung zu den Erfolgschancen geben zu können.",
    image: {
      src: ourServiceImg03,
    },
  },
  {
    id: "04",
    title: "Persönliche Beratung",
    description:
      "Gemeinsam finden wir den besten Weg. Im stetigen Austausch und durch Beratungsgespräche, erklären wir Ihnen die rechtlichen Möglichkeiten und legen individuell das Vorgehen fest, damit Sie bestmöglich zu Ihrem Recht gelangen.",
    image: {
      src: ourServiceImg04,
    },
  },
  {
    id: "05",
    title: "Wir legen los",
    description:
      "Ihr Recht im Fokus. Wir setzen uns mit voller Entschlossenheit dafür ein, dass Ihr Anliegen so schnell wie möglich gelöst wird und Sie wieder Zeit für die vielen schönen Dinge im Leben haben!",
    image: {
      src: ourServiceImg05,
    },
  },
];
